import React from 'react';
import PropTypes from 'prop-types';
import MapSenate from '../Map/Senate';
import { Header, Map, Total, Party, SmartTitle, SummaryButton, Logo, Line, LineWrap, mandates } from './styles';
import colors from '../../colors';
import { percentFormat } from '../../Utils/NumberFormatting';
import { Button } from '../InterestingDistricts/styles';

export default class WidgetSummary extends React.PureComponent {
	onClick = (id) => {
		window.top.location.href = `${this.props.link}#/obvod/${id}`;
	}

	render() {
		const max = this.props.parties[0] ? this.props.parties[0].count : 0;
		return <>
			<Header>
				<SmartTitle>Senátní volby - Výsledky ve 2. kole</SmartTitle>
				<Total className={mandates}>Počet mandátů:</Total>
				<Total>
					Volební účast: {percentFormat(this.props.meta.turnout, 2)}
				</Total>
				<Button className={SummaryButton} reverse href={this.props.link}>
					Přehled všech obvodů
				</Button>
			</Header>
			<Map>
				<MapSenate
					districts={this.props.districts}
					leaders={this.props.leaders}
					mapProps={{ viewBox: '0 0 420 237', height: '177', overflow: 'hidden' }}
					onClick={this.onClick}
					roundIndex={1}
				/>
			</Map>

			{this.props.parties.map((party, index) => {
				const relative = max ? party.count / max * 100 : 0;
				return <Party key={index}>
					<Logo alt={party.shortcut} src={this.props.logos[party.id] || ''} width="40" height="40" />
					<LineWrap>
						<Line
							style={{
								backgroundColor: colors[party.id] || colors.default,
								width: relative +'%'
							}}
						>
							{party.count}
						</Line>
					</LineWrap>
				</Party>;
			})}
		</>;
	}
}

WidgetSummary.propTypes = {
	meta: PropTypes.shape({
		turnout: PropTypes.number.isRequired
	}).isRequired,
	link: PropTypes.string.isRequired,
	districts: PropTypes.arrayOf(PropTypes.number).isRequired,
	leaders: PropTypes.object.isRequired,
	logos: PropTypes.object
}

WidgetSummary.defaultProps = {
	logos: {}
}
